import React from 'react'
import cms from '../../assets/images/cms.svg'

const HomeLibecms = () => {
    return (
        <div className='home-libecms'>
            <div className='title'>
                <div className='cms-title'>
                    <h3>Enhance Your Digital Presence with <h4 className='cms'><h4 className='color3'>LIBE</h4><h4 className='color4'>CMS</h4></h4></h3>
                </div>
            </div>
            <div>
                <img src={cms} alt='' className='cms-img' />
            </div>
        </div>
    )
}

export default HomeLibecms
